/**
 * Shared Rate My Trade helpers for the shell surfaces.
 */

const VOTES_KEY = 'ft_rmt_votes';

export const readVotes = () => {
  try {
    return JSON.parse(localStorage.getItem(VOTES_KEY)) || {};
  } catch {
    return {};
  }
};

export const recordVote = (shareId, vote) => {
  const votes = readVotes();
  votes[shareId] = vote;
  localStorage.setItem(VOTES_KEY, JSON.stringify(votes));
  return votes;
};

/* Identity rule: wherever the UI names the acting person, lead with the
   manager username (ownerName). Team names are secondary context. */
export const sideLabels = (trade) => {
  const cached = trade.cachedTeamData || {};
  const a = cached.teamA?.ownerName || trade.creatorDisplayName || 'Side A';
  const b = cached.teamB?.ownerName || trade.otherOwnerName || 'Side B';
  return [a, b];
};

/* Server counts already include recorded votes — components bump local state
   exactly once at vote time; this stays pure. */
export const votePct = (trade) => {
  const yes = Number(trade.yesCount || 0);
  const no = Number(trade.noCount || 0);
  const total = yes + no;
  return { total, send: total ? Math.round((yes / total) * 100) : 50 };
};
